import { Button, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useCallback } from 'react';
import { useAuthData } from './use-auth-data';
import { useProjectId } from '~/hooks/context/useProjectId';

const REQUIRED_ROLE = 'Developer' as const;

export const useManageApiKeyPage = () => {
  const projectId = useProjectId();
  const { accessHelper, activeOrg } = useAuthData();
  const activeOrgId = activeOrg?.orgId;

  const showModalIfNotAuthorized = useCallback(
    (e: React.MouseEvent) => {
      if (activeOrgId && accessHelper?.isAtLeastRole(activeOrg?.orgId, REQUIRED_ROLE)) {
        return;
      }
      e.preventDefault();
      modals.open({
        title: 'Permission Required',
        centered: true,
        children: (
          <div className="flex flex-col gap-4">
            <Text>You need {REQUIRED_ROLE.toLowerCase()} permissions in your workspace to perform this action.</Text>
            <Text>
              Please request access from your workspace owner, or reach out to{' '}
              <a
                href="mailto:help@stably.ai"
                className="text-blue-600 hover:underline dark:text-blue-400"
              >
                help@stably.ai
              </a>{' '}
              for assistance.
            </Text>
            <Button
              onClick={() => modals.closeAll()}
              className="mt-2"
            >
              Close
            </Button>
          </div>
        ),
      });
    },
    [activeOrgId, accessHelper],
  );

  return {
    showModalIfNotAuthorized,
    manageApiKeyPageUrl: `/project/${projectId}/settings?tab=api-key`,
  };
};
